<!-- <mat-sidenav-container>
    <mat-sidenav #sidenav position="end" fixedInViewport>
        <mat-toolbar><button mat-icon-button (click)="sidenav.close()"><mat-icon>close</mat-icon></button></mat-toolbar>
        <app-jobdetails (openSidebar)="sidenav.open()" cdkFocusInitial></app-jobdetails>
    </mat-sidenav>
    <mat-sidenav-content>
    </mat-sidenav-content>
</mat-sidenav-container> -->
<app-toolbar></app-toolbar>
<router-outlet></router-outlet>